module.exports = __webpack_public_path__ + "static/media/profile-img.ed09dbaf.png";